module.exports = __webpack_public_path__ + "media/images/sections/real_world_connection-abe4b087d5ba20277c53b2d858783beb.png";